module.exports = __webpack_public_path__ + "img/0826-chevron-up.63ecfb91.svg";